export default {
  documentTitle: 'Management',
  id: 'ID',
  createdAt: 'Created at',
  updatedAt: 'Updated at',
  new: 'New',
  detail: 'Detail',
  edit: 'Edit',
  destroy: 'Destroy',
  operateSuccess: 'Operate Success',
  approveAndSentSuccess: 'Approved, and send ref code success',
  testerTitleInListPage: 'Tester(only show the testers which create by this platform)',
  suggestSize: 'Suggest size',
  createApplication: 'Create application',
  logout: 'Logout',
  choiceRole: 'Choice role',
  miniProgram: 'Mini program',
  waitForBinding: 'Wait for binding',
  waitForWechatAudit: 'The application for registration has been submitted, wait for audit',
  miniProgramRegistrationFail: 'Mini program registration failed, click for more information',
  yesterdayPageView: 'Yesterday page view',
  yesterdayUserView: 'Yesterday user view',
  customPlan: 'Plan',
  standardPlan: 'Standard',
  expired: 'Expired',
  expiredTime: 'The due time is',
  expiredTips: 'Mini program will be closed when plan expired, you can contact customer to upgrade or recharge the plan.',
  contactCustomer: 'Contact customer',
  customerPhone: 'Customer phone',
  customerEmail: 'Customer email',
  longTermEffective: 'Long term effective',
  visitsInTheLastWeek: 'Visits in the last week',
  pageView: 'Page view',
  userView: 'User view',
  noData: 'No Data',
  usersCount: 'Users count',
  membersCount: 'Members count',
  newUserStatistics: 'New user statistics',
  userGenderDistribution: 'User gender distribution',
  userGender: 'User gender',
  userTypeDistribution: 'User type distribution',
  userType: 'User type',
  notAssociatedApplication: 'The current account is not associated with any applications',
  changePassword: 'Change password',
  currentPassword: 'Current password',
  newPassword: 'New password',
  confirmPassword: 'Confirm password',
  error: 'Error',
  pleaseLogin: 'Please login',
  verificationCodeSendSuccessfully: 'Verification code send successfully',
  productsCount: 'Wines count',
  postsCount: 'Posts count',
  messagesCount: 'Messages count',
  unreadMessagesCount: 'Unread messages count',
  count: 'Count',
  unauthorized: 'Unauthorized',
  unlockWallet: 'Unlock wallet',
  resetPassword: 'Reset PIN',
  resetPasswordSuccess: 'Operate Success. The one time PIN has been sent to the user.',
  exportTicketsQrcode: 'Export tickets qrcode',
  exporting: 'The file is being exported, and it will be sent to the mailbox after the export is successful',
  show: 'Show',
  hide: 'Hide',
  download: 'Download',
  resolve: 'Resolve',
  suspended: 'Suspended',
  before: 'before',
  after: 'after',
  sendReward: 'Send reward',
  dayOfWeek: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },
  actions: {
    user: {
      isBlockToTrue: 'Suspend',
      isBlockToFalse: 'Unsuspend',
      approve: 'Approve',
      reject: 'Reject',
      unlockRedPacketFunction: 'Unlock grab function',
      lockWalkAccount: 'Suspend steps',
      unlockWalkAccount: 'Unsuspend steps',
    }
  },
  login: {
    manageSystem: 'Manage System',
    remenberPassword: 'Remember password',
    forgetPassword: 'Forgot password?',
    login: 'Login',
    loginSuccess: 'Login success',
    inputEmail: 'Input email',
    inputPassword: 'Input password',
    confirmNewPassword: 'Confirm new password',
    inputRucaptcha: 'Input captcha',
    resetPassword: 'Reset password',
    resetPasswordSuccess: 'Reset password success',
    sendVeirificationSuccess: 'Verification code has been sent',
    missingLoginName: 'Email is required',
    sendResetPasswordEmailSuccess: 'Reset password email has been sent',
    getResetPasswordEmail: 'Get Reset Password Email',
    signUp: 'Sign up',
    sendVerificationCode: 'Send',
    inputVerificationCode: 'Input code',
    setPassword: 'Input password',
    signIn: 'Sign in',
    signUpSuccess: 'Registered success',
  },
  wechatMiniProgram: {
    analysis: {
      refDate: 'Time',
      sessionCnt: 'Open count',
      visitPv: 'Number of visits',
      visitUv: 'Number of visitors',
      visitUvNew: 'Number of new users',
      stayTimeUv: 'Average stay time per capita',
      stayTimeSession: 'Average stay time per visit',
      visitDepth: 'Average visit depth',
      retentionUvNew: 'Retention of new users',
      retentionUvActive: 'Retention of active users',
      retainedUsers: 'Number of retained users',
      genderAndAge: 'Gender and age',
      platformAndDevice: 'Platform and device',
      portraitOfNewUsers: 'Portrait of new users',
      portraitOfActiveUsers: 'Portrait of active users',
      pagePath: 'Page path',
      pageVisitPv: 'Number of visits',
      pageVisitUv: 'Number of visitors',
      pageStaytimePv: 'Average stay time per visit',
      entrypagePv: 'Number of page entries',
      exitpagePv: 'Number of page exits',
      pageSharePv: 'Number of forwards',
      pageShareUv: 'Number of forwarders',
      retainInfo: 'Retain Info',
      userPortrait: 'User portrait',
      accessSourceSessionCnt: 'Visit source distribution',
      accessStaytimeInfo: 'Visit duration distribution',
      accessDepthInfo: 'Visit depth distribution',
      sourceAnalysis: 'Source analysis',
      gender: 'Gender',
      age: 'Age',
      region: 'Region',
      province: 'Province',
      city: 'City',
      platform: 'Platform',
      device: 'Device',
      yesterday: 'Yesterday',
      latest7Day: 'Latest 7 days',
      latest30Day: 'latest 30 days',
      time: 'Time',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      pleaseSelectDate: 'Please select date',
      pleaseSelectWeek: 'Please select week',
      pleaseSelectMonth: 'Please select month',
      weeklyFormat: 'yyyy week WW',
      timeDayLater: '%{value} day later',
      timeWeekLater: '%{value} week later',
      timeMonthLater: '%{value} month later',
      visitDistribution: 'Visit distribution',
      summaryAndVisitPage: 'Summary and visit page',
      visitTrend: 'Visit trend',
      visitRetain: 'Visit retain',
      visitPage: 'Summary and visit page',
    }
  },
  hint: {
    cannotChangeAfterCreate: 'Can not change after create',
    positionColumn: 'The smaller the value, the higher the priority',
    searchByPhone: 'Enter phone number to search',
    inputPhoneNumber: 'Input phone number',
    merchantCashbackPercentHint: '0 means no cashback percent',
    zeroMeansNoLimit: '0 means no limit',
    unlockRedPacketFunctionHint: 'The user operates too frequently and has reached the limit for searching and receiving grabs today. Confirm the unblocking so that the user can continue to search and receive grabs today?',
    exportTicketsQrcodeSuccess: 'Operate success. The export will take some time. Please refresh the page later to view the qrcode download link.',
    ticketNumberStartAtHint: 'The number displayed on the first ticket when exporting ticket qrcode. Subsequently generated numbers will be automatically incremented by one.',
    turnOffSmsNotificationPlatformsHint: 'After selecting a platform, the platform will not receive any other notifications except the verification code SMS.',
    remainingAfterDeductingPendingWithdrawal: 'Remaining after deducting pending withdrawal amount',
    currentUserOrAgent: 'Current user or payment account',
    merchantNotActived: 'The store does not have an approved/activated and unsuspended payment account and will not show up in the client APP',
    walkStepRecordIsActiveHint: 'Hint: 1. If user log in to multiple devices using the same account, only the device with the highest number of steps on the day will be actived. 2. If user log in to multiple accounts on the same device, only the steps of the first account for the day will be actived.',
    walkChallengeParticipationRecordRankHint: 'Hint: The rank is sorted by steps. In order to avoid tied rankings, if the steps is the same, the user who participated first will be ranked first. In this way, rewards can be clearly distributed based on rankings.',
    first_wallet_holder_of_the_same_device_hint: 'Previously account used on this device',
  },
  menu: {
    productManagement: 'Wine management',
    merchantManagement: 'Winery management',
    eventManagement: 'Event management',
    userManagement: 'User management',
    pageManagement: 'FAQ',
    applicationManagement: 'Application management',
    contentManagement: 'Content management',
    homePage: 'Home',
    dataAnalysis: 'Data analysis',
    storeManagement: 'Store management',
    placesListing: 'Places listing',
    merchantCatalog: 'Catalog',
    exploreSection: 'Explore section',
    userVerifications: 'Verification',
    request: 'Requests',
    smsPush: 'Sms push',
    transactions: 'Transactions',
    allTransactions: 'All transactions',
    clientAppPush: 'Client app push',
    agentAppPush: 'Merchant app push',
    notifications: 'Notifications',
    rulesAndKycs: 'Rules & KYCs',
    appVersionSettings: 'App version settings',
    specificVerificationCodes: 'Specific verification codes',
    newStoreOwner: 'New store owner',
    ledger: 'Ledger',
    analytics: 'Analytics',
    masterLedger: 'Master ledger',
    liveEvents: 'Live events',
    eventHistory: 'Event history',
    createEvent: 'Create event',
    addTickets: 'Add tickets',
    loyaltyPrograms: 'Loyalty programs',
    grab: 'Grab',
    cashback: 'Cashback',
    redPacketSettings: 'Grab settings',
    walk: 'Walk',
    electricity: 'Electricity',
    airtime: 'Airtime',
    adSpace: 'Ad space',
    videoSpace: 'Video space',
    winners: 'Winners',
    redPacketJoga: 'Grab Joga',
  },
  model: {
    activeStorageBlob: 'Media upload'
  },
  activeStorageBlob: {
    filename: 'Filename',
    contentType: 'Content type',
    url: 'Content',
    contentTypes: {
      image: 'Image',
      video: 'Video',
      audio: 'Audio',
      text: 'Text',
      xml: 'XML',
      json: 'JSON',
      pdf: 'PDF',
      sheet: 'Sheet'
    }
  },
  customPage: {
    publish: 'Publish',
    default: 'Preset page',
    preview: 'Preview',
  },
  application: {
    miniProgram: 'Mini program',
    shareDesc: 'Share description',
    wechatOfficialAccountURL: 'Wechat official account URL',
    homeTopLogo: 'Chinese/English logo',
    homeBottomLeftLogo: 'English logo',
    questionaireTopImage: 'Image in the top of questionaire',
    questionaireBackgroundImage: 'Background image of questionaire',
    personalCenterBackgroundImage: 'Background image of personal center',
    myCardsBackgroundImage: 'Background image of my cards',
    wechatApplication: {
      trialSubmition: {
        userVersion: 'Trail version',
        trialVersionQrcode: 'Trail version qrcode',
        userDesc: 'Trail version desc',
      },
      onlineSubmition: {
        userVersion: 'Online version',
        userDesc: 'Online version desc',
      },
      auditSubmition: {
        userVersion: 'Audit version',
        userDesc: 'Audit version desc',
        state: 'Audit state',
        reason: 'Reaseon',
      },
      qrcodeURL: 'Online version wxacode',
    },
    actions: {
      submitAudit: 'Submit audit',
      simulateSubmitAudit: 'Simulate submit audit',
      release: 'Release',
      simulateRelease: 'Simulate release',
      updateExpiredAt: 'Change expired at',
      reauthorization: 'Reauthorization',
      bindMiniProgram: 'Bind mini program'
    },
  },
  page: {
    presetPage: 'Preset page',
  },
  banner: {
    targetUrl: 'Target url'
  },
  adminUser: {
    password: 'Password',
    passwordConfirmation: 'Password confirmation'
  },
  plutus_entries: {
    commercial_document_kind: 'Transaction kind',
    description: 'Description',
    commercial_document_id: 'Transaction detail ID',
    target_type: 'Trader type',
    target_id: 'User/Payment account ID',
    month: 'Month',
    date_gteq: 'Transaction date after',
    date_lteq: 'Transaction date before',
    commercial_document: 'Transaction detail',
    date: 'Date',
    balance_remain_amount: 'Balance remain amount',
    topup_amount_from_agent: 'Topup amount from agent',
    total_transaction_volumn: 'Total transaction volumn',
    withdraw_amount: 'Withdraw amount',
    avatar: 'Avatar',
    first_name: 'First name',
    last_name: 'Last name',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    gender: 'Gender',
    whatsapp: 'Whatsapp',
    transaction_at: 'transaction at',
    created_at: 'Created at',
    updated_at: 'Updated at',
    number: 'Transaction ID',
    debitor_number: 'Debitor phone',
    creditor_number: 'Creditor phone',
    profile_attributes: 'Profile',
    creditor_type: 'Creditor type',
    debitor_type: 'Debitor type',
    kind: 'Kind',
    state: 'State',
    creditor_miapay_wallet_holder: 'Creditor wallet holder',
    debitor_miapay_wallet_holder: 'Debitor wallet holder',
    amount_cents: 'Amount (FCFA)',
    cashback_amount_cents: 'Coins (MPC)',
    user: 'User',
    agent: 'Payment account',
    remark: 'Remark',
    user_or_agent_phone: 'User/Payment account phone',
    commercial_document_kind_map: {
      topup: 'Topup',
      withdraw: 'Withdraw',
      transfer: 'Transfer',
      pay_with_qr_code: 'Pay with qr code',
      cashback: 'Cashback',
      create_red_packet: 'Create grab',
      receive_red_packet: 'Receive grab',
      red_packet_expire: 'Grab expire',
      order_ticket: 'Order ticket',
      electricity: 'Electricity',
      airtime: 'Airtime',
    }
  },
  sms: {
    allUsers: 'All users',
    allAgents: 'All agents',
    phones: 'Phones',
    enMessage: 'English message',
    frMessage: 'French message',
    messageHint: 'The built-in variables enclosed in square brackets are: %{variables}. They will be replaced with actual content before sending.'
  },
  setting: {
    customerServicePhone: 'Customer service phone',
    customerServiceWhatsapp: 'Customer service whatsapp',
    customerServicseEmail: 'Customer service email',
    internalTestAccountPhones: 'Internal test account phone number',
    internalTestAccountPhonesHint: 'For the convenience of testing, these accounts do not require actual payment, and transactions can be completed directly',
    cashbackRules: 'Cashback rules (FCFA)',
    signUp: 'Sign up',
    firstPayment: 'First payment',
    firstTopup: 'First topup',
    loginPerDay: 'Daily login / Once per day',
    transfer: 'Transfer',
    paymentToMerchants: 'Payment to merchants',
    topupFromMobileMoney: 'Topup from mobile money',
    bindInvitor: 'Scan QR code to bind invitor',
    invitedPerUser: 'Invited per user',
    paymentToMerchantsHint: 'Payment to merchants if no existent deal on the platform',
    kycRules: 'KYC rules (FCFA)',
    monthlyTransactionLimit: 'Monthly Limit of transaction',
    dailyTransactionLimit: 'Daily Limit of transaction',
    walletBalanceLimit: 'Wallet balance limit',
    maxAmountPerRedPacket: 'Maximum amount of per grab created',
    dailyRedPacketCreatedCountLimit: 'Maximum grabs number that can be created per day',
    dailyRedPacketCreatedAmountLimit: 'Maximum grabs amount that can be created per day',
    clientAppVersions: 'Client app versions',
    agentAppVersions: 'Agent app versions',
    smsProvider: 'SMS provider',
    ticketEventPoster: 'Ticket event poster',
    recommendedTicketEvent: 'Recommended ticket event',
    explorePoster: 'Explore poster',
    appVersions: {
      version: 'Version',
      buildID: 'Build ID',
      force: 'Force',
      link: 'Link',
    },
    appClient: 'Platform',
    appClients: {
      Client: 'MiaPay',
      Agent: 'MiaPay Collect',
    },
    phone: 'Phone',
    code: 'Specific code',
    codeHint: 'Please enter 4 digits',
    enabled: 'Enabled',
    turnOffSmsNotificationPlatforms: 'Turn off sms notification platforms',
    minimumTransactionAmounts: 'Minimum transaction amounts',
    topup: 'Topup',
    payWithQrCode: 'Pay with qr code',
    withdraw: 'Withdraw',
    transferAmountMultiple: 'The transfer/pay with qr code amount needs to be a multiple of',
    explorePageRedPackageCode: 'Explore page grab',
    jogaRedPackageCode: 'Joga grab',
    showWithdrawalFunctionSuspendedPopup: 'Show withdrawal function suspended popup',
  },
  withdrawalApplication: {
    miapayAccountNumber: 'Miapay account number',
    paymentAccountNumber: 'Mobile money account number',
    userName: 'User name'
  },
  merchant: {
    removeFromPlacesSection: 'Remove from places listing',
    addToPlacesSection: 'Add to places listing',
    removeFromMerchantCatalog: 'Remove from catalog',
    addToMerchantCatalog: 'Add to catalog',
    removeFromExploreSection: 'Remove from explore section',
    addToExploreSection: 'Add to explore section',
    qrCode: 'QR code'
  },
  redPacket: {
    manuallyReturn: 'Manually return expired',
    customListItem: 'Ad space',
    types: {
      "RedPacket::Brand": "Brand",
      "RedPacket::Normal": "Normal",
      "RedPacket::Joga": "Joga",
    }
  },
  homePage: {
    userCount: 'User count',
    newUserTrend: 'New user trend',
    newUserCount: 'New user count',
    newActivedUserCount: 'New actived user count',
    newAdminUserCount: 'New admin user count',
    activedUserCount: 'Actived user count',
    agentCount: 'Agent count',
    activedAgentCount: 'Actived agent count',
    newAgentTrend: 'New agent trend',
    newAgentCount: 'New agent count',
    newActivedAgentCount: 'New actived agent count',
    newTransactionsTrend: 'New transactions trend',
    newTransactionsCount: 'New transactions count',
    pendingStoreOwner: 'Pending Store Owner',
    pendingUserVerification: 'Pending User verification',
    pendingMerchantWithdrawalRequest: 'Pending merchant withdrawal request'
  },
  adminUsersRole: {
    refCodeRequestedEmail: 'Ref code requested notification email',
    withdrawalApplicationRequestedEmail: 'Withdrawal application requested notification email',
    feedbackAddedEmail: 'Feedback added notification email',
    walletAddedEmail: 'Wallet added notification email',
    walletRemovedEmail: 'Wallet removed notification email',
    userVerifiedEmail: 'User verified notification email',
  },
  storeOwner: {
    agentStatus: 'Account state',
  },
  masterLedger: {
    total_amount_in_ledger: 'Total amount in ledger',
    total_amount_in_agent_wallets: 'Total amount in agent wallets',
    total_amount_in_client_wallets: 'Total amount in client wallets',
    total_number_of_agent_wallets_created: 'Total number of agent wallets created',
    total_number_of_client_wallets_created: 'Total number of client wallets created',
    total_number_of_actived_agent_wallets: 'Total number of actived agent wallets',
    total_number_of_actived_user_wallets: 'Total number of actived user wallets',
    total_amount_of_cashback_given: 'Total amount of cashback given',
    cashback_amount_trend: 'Cashback amount trend',
    total_number_of_transactions: 'Total number of transactions',
    average_transactions: 'Average transactions',
  },
  user: {
    agentVerifier: 'Agent',
    isDeleted: 'Deleted',
  },
  ticketAnalysics: {
    totalTicketSolds: 'Total ticket solds',
    revenue: 'Revenue (FCFA)',
    checkedIn: 'Checked in',
    revenueByTicketType: 'Revenue by ticket type',
  },
  customListItem: {
    image: 'Image',
    video: 'Video',
    videoCover: 'Video cover',
    externalLink: 'External link',
    target: 'Target link',
    targetType: 'Target type',
  },
  walkAnalysics: {
    totalWalkersCount: 'Total walkers',
    thisMonthActiveWalkersCount: 'Active this month',
    lastHourActiveWalkersCount: 'Active last hour',
    totalKilometersDistance: 'Total distance (Km)',
    walkJoinedAt: 'Stated',
    walkLastActiveAt: 'Last active at',
    newJoinedCount: 'New joined count',
    ActivedWakerCount: 'Active count',
  },
  challengeAnalysics: {
    joinedCount: 'Joined count',
    activeCount: 'Active count',
    completedCount: 'Completed count',
    incompleteCount: 'Incomplete count',
    winnersCount: 'Winners count',
  },
}
